import '../css/basic.scss'

function handleMessage(e) {
  const { event, payload } = e.data
  if (!event) return

  switch (event) {
    case 'js':
      eval(payload)
      break
    case 'css':
      document.getElementById('host-style').innerHTML = payload
      break
    case 'restart':
      BotSqd.message('.stop')
      setTimeout(() => document.location.reload(), 100)
      break
    case 'config':
      const { key, value } = payload
      BotSqd.config(key, value)
      break
  }
}

function initializePush() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  if (window.self !== window.top) {
    console.log('Loaded in frame, skipping service worker')
    return
  }

  navigator.serviceWorker
    .register('/sw.js')
    .then(reg => {
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ cache: document.location.href })
      }

      reg.onupdatefound = () => {
        const installingWorker = reg.installing
        installingWorker.onstatechange = () => {
          switch (installingWorker.state) {
            case 'installed':
              if (navigator.serviceWorker.controller) {
                caches
                  .keys()
                  .then(l => Promise.all(l.map(k => caches.delete(k))))
                  .then(r => document.location.reload())
              } else {
                console.log('No update found')
              }
              break
          }
        }
      }

      BotSqd.onEmit('$push_register', () =>
        BotSqd.subscribeToPushEvents(reg.pushManager, document.body.dataset.pushApplicationKey)
          .then(res => BotSqd.event('$push_register_ok'))
          .catch(res => BotSqd.event('$push_register_fail')),
      )
    })
    .catch(e => console.log(e))
}

document.addEventListener('DOMContentLoaded', () => {
  window.addEventListener('message', handleMessage)
  initializePush()
})
